module.exports = __webpack_public_path__ + "static/media/logo.9e5d4fc7.png";